/**
 *
 * Asynchronously loads the component for MetaAI
 *
 */

import { lazyLoad } from 'utils/loadable';

export const MetaAI = lazyLoad(
  () => import('./index'),
  module => module.MetaAI,
);
